import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { AbstractPage } from '../_com/abstract-page';
import { HttpStaffProvider } from '../../providers/http-staff';
import { StaffAction } from '../../actions/staff.action';

/**
 * Generated class for the PasswordResetPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-password-reset',
  templateUrl: 'password-reset.html',
})
export class PasswordResetPage extends AbstractPage{

  phoneNumber: "";

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public alertController: AlertController, 
    public httpStaffProvider: HttpStaffProvider, 
    private staffAction: StaffAction
    ) {
    super();
  }

  ionViewDidLoad() {
  }

  /**
   * 対象電話番号のパスワードをリセットする
   */
  next() {

    if (!this.phoneNumber){
      this.alert(this.alertController, "電話番号を入力してください");
    } else {

      this.confirm(this.alertController, "この電話番号を初期化します。よろしいですか？", ()=>this.reset());
    }
  }

  reset(){

    this.staffAction.passwordReset(this.phoneNumber).subscribe(status => {

      var msg = (status) ? this.phoneNumber + "のパスワードを電話番号に初期化しました" : "パスワードリセットに失敗しました";
      super.alert(this.alertController, msg);
      if (status){
        this.navCtrl.pop();
        return;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/password-reset/password-reset.ts